import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectCreationError() {
      return getState().error;
    },
    isProjectCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isProjectCreationRequestPending() {
      return getState().request.isPending;
    },
    isProjectCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
